import React, { Component } from 'react';
import { Grid, Cell, Navigation } from 'react-mdl';
import { Link } from 'react-router-dom';
import 'pure-react-carousel/dist/react-carousel.es.css';

import Flags from 'country-flag-icons/react/3x2'
import getUnicodeFlagIcon from 'country-flag-icons/unicode'
import { AnimateOnChange } from 'react-animation'

import { View, Text, Pressable, Linking, Image, ActivityIndicator, Alert, FlatList } from "react-native";

//Firebase
import app from 'firebase/app';
import firebase from '@firebase/app';
import '@firebase/firestore'

//Helpers
import MainStyles from '../mainstyles.js'
import GLOBAL from '../global.js'

//Module
import ReactGA from 'react-ga';

var height = 100
var spacing = 10
var moment = require('moment-timezone');

var stringChangeTime = 8000

class Item extends Component {

  constructor(props) {
    super(props);
    this.state = {
      match:{},
      style:{},

      loading:true,
      firstSet:true,

      mode:'selectMatch',
      matches:[],
      topTippers:[],
      stats:[],

      activeIndex_stats:-1,
      activeIndex_tippers:-1,
      tippers:[],
      stats:[],
      string_stats:'',
      string_tippers:'',
      stats_title:'Match Stats',
    };
  }

  componentDidMount = async () => {
    this.setup()
  }

  componentWillUnmount = async () => {
    if(this.listenMatch){
      this.listenMatch()
    }
    if(this.listenMatchStats){
      this.listenMatchStats()
    }
    clearTimeout(this.updateString_tippers)
    clearTimeout(this.updateString_stats)
  }

  reset = async () => {
    await this.setState({
      match:{},
      style:{},

      loading:true,
      firstSet:true,

      mode:'selectMatch',
      matches:[],
      topTippers:[],
      stats:[],

      activeIndex_stats:-1,
      activeIndex_tippers:-1,
      tippers:[],
      stats:[],
      string_stats:'',
      string_tippers:'',
      stats_title:'Match Stats',
    })
    this.setup()
  }

  setup = async () => {
    //Get available matches - live + scheduled
    var live_raw = []
    var live = []
    var scheduled_raw = []
    var scheduled = []

    var categories = ['ATP', 'WTA', "Challenger", "Davis Cup", "Exhibition"]

    await firebase.firestore()
    .collection('summaries_sr').doc('live')
    .get()
    .then(async (doc) => {
      live_raw = Object.values(doc.data().matches)
    })

    await firebase.firestore()
    .collection('summaries_sr').doc('scheduled')
    .get()
    .then(async (doc) => {
      scheduled_raw = Object.values(doc.data().matches)
    })

    //Get all the UTS matches
    var matches_uts = []
    await firebase.firestore()
    .collection('matches_sr')
    .where("competition_name", '==', 'Ultimate Tennis Showdown 4')
    .get()
    .then(async (querySnapshot) => {
      if(querySnapshot.size > 0){
        await querySnapshot.forEach(async (doc) => {
          var matchData = doc.data()
          matchData.docId = doc.id
          matches_uts.push(matchData)
        })
      }
    })

    await Promise.all(live_raw.map(async match => {
      match.isLive = true
      if(categories.includes(match.category)){
        live.push(match)
      }
    }))

    //Promise through upcoming and only show ones starting in the next hour
    await Promise.all(scheduled_raw.map(async match => {
      var buffer = Date.now() + (12 * 60 * 60 * 1000)
      if(Number(match.start_time_timestamp) <= buffer && categories.includes(match.category)){
        scheduled.push(match)
      }
    }))

    await live.sort((a, b) => (a.startedAt < b.startedAt) ? 1 : -1);
    await scheduled.sort((a, b) => (Number(a.start_time_timestamp) > Number(b.start_time_timestamp)) ? 1 : -1);

    var matches = matches_uts.concat(live).concat(scheduled)

    // await matches.sort((a, b) => (a.startedAt < b.startedAt) ? 1 : -1);

    await Promise.all(matches.map(async match => {
      //Fix the names
      if(match.competitors[0].name.includes(', ')){
        match.competitors[0].name = (match.competitors[0].name.split(", "))[1].charAt(0) + ". " + (match.competitors[0].name.split(", "))[0]
      }

      if(match.competitors[1].name.includes(', ')){
        match.competitors[1].name = (match.competitors[1].name.split(", "))[1].charAt(0) + ". " + (match.competitors[1].name.split(", "))[0]
      }
    }))

    this.setState({matches, loading:false})
  }

  selectMatch = async (id) => {
    await this.changeTheme()

    //Get the match from firestore and listen
    this.listenMatch = await firebase.firestore()
    .collection('matches_sr')
    .where('id', '==', id)
    .onSnapshot(this.handleMatch)

  }

  handleMatch = async ( querySnapshot ) => {
    var match = {}
    var docId = null

    if(querySnapshot.size > 0){
      await querySnapshot.forEach(async (doc) => {
        match = doc.data()
        docId = doc.id

        //Correct the player names
        if(match.competitors[0].name.includes(', ')){
          match.competitors[0].name = (match.competitors[0].name.split(", "))[1].charAt(0) + ". " + (match.competitors[0].name.split(", "))[0]
        }

        if(match.competitors[1].name.includes(', ')){
          match.competitors[1].name = (match.competitors[1].name.split(", "))[1].charAt(0) + ". " + (match.competitors[1].name.split(", "))[0]
        }
      })
    }

    if(this.state.firstSet && docId){
      this.setupListeners(docId, match)
    }

    this.setState({match, loading:false, mode:'match', firstSet:false})
  }

  setupListeners = async (docId, match) => {
    var status = match.match_status
    //Get stats & h2h
    this.listenMatchStats = await firebase.firestore()
    .collection('matches_sr').doc(docId)
    .collection('info').doc('stats')
    .onSnapshot(this.handleStats)

    this.listenTippers = await firebase.firestore()
    .collection('streaming').doc("yBhmZeRfAZ7rzm8jemwX")
    .onSnapshot(this.handleTippers)

    if(status === 'not_started'){
      await firebase.firestore()
      .collection('matches_sr').doc(docId)
      .collection('info').doc('data')
      .get()
      .then(async(doc)=>{
        if(doc.exists && doc.data()){
          var stats = []
          var stats_title = 'H2H Record'
          var h2h = doc.data().h2h_v2

          if(h2h){
            //Generate the H2H record string
            var record = h2h.wins
            if(record[0] > record[1]){
              stats.push(match.competitors[0].name + " leads the H2H " + record[0] + "-" + record[1])
            }else if(record[1] > record[0]){
              stats.push(match.competitors[1].name + " leads the H2H " + record[1] + "-" + record[0])
            }else{
              //Tied
              stats.push("H2H is tied at " + record[0] + "-" + record[1])
            }

            var matches = h2h.matches || []
            await Promise.all(matches.map(async (h2h_match, index) => {
              stats.push(h2h_match.winner + " won in the "+ h2h_match.round + " at the " + h2h_match.tournament + " in " + moment(h2h_match.timestamp, 'x').format('YYYY') + "  -  " + h2h_match.score)
            }))

            await this.setState({stats, stats_title})
            this.changeString_stats()
          }

        }
      })
    }
  }

  handleTippers = async (doc) => {
    //Set state and setup string changing timers
    // var tippers = [
    //   "Here's the first stat",
    //   "Here's the next stat",
    //   "And what about htis stats",
    // ]

    var tippers = []

    if(doc.data() && doc.exists){
      tippers = doc.data().topTippers || []

      tippers = [tippers.join("   ·   ")]

      await this.setState({tippers})

      this.changeString_tippers()
    }
  }

  handleStats = async (doc) => {
    var { match } = this.state
    if(doc.data() && doc.exists){
      var stats = ["Match Stats powered by TNNS - DOWNLOADTENNIS.COM"]
      var statsRaw = doc.data().stats || []

      //Setup names
      var p1 = match.competitors[0].name || ''
      var p2 = match.competitors[1].name || ''

      //Promise through stats and add values
      if(statsRaw){
        await Promise.all(statsRaw.map(async stat_period => {
          if(stat_period.title === 'Match'){
            var period_stats = stat_period.stats.stats || []
            await Promise.all(period_stats.map(async stat_group => {
              await Promise.all(stat_group.data.map(async stat => {
                if(stat.values){
                  if(stat.values[0] && stat.values[1]){
                    var p1_stat = p1 + " - " + stat.values[0]
                    var p2_stat = p2 + " - " + stat.values[1]

                    stats.push(
                      stat.title + ":     " + p1_stat + "     " + p2_stat
                    )
                  }
                }
              }))
            }))
          }
        }))
      }

      var stats_title = 'Match Stats'
      await this.setState({stats, stats_title})
      this.changeString_stats()

    }else{
      var stats = ["Match Stats powered by TNNS - DOWNLOADTENNIS.COM", "Stats available soon"]
      await this.setState({stats})
      this.changeString_stats()
    }
  }

  changeTheme = async (theme) => {
    var style = {
      background_main:"#101012",
      background_match:'#18181B',
      background_tnns:'#18181B',
      background_scores:"#18181B",
      background_ticker:'#18181B',
      font_ticker:'white',
      font_color:'white',
      game_color:'white',
      set_color:'white',
      player_color:'white',
      player_font:'Averta-Bold',
      ball_color:GLOBAL.colors.volt,
      event_logo:"https://pbs.twimg.com/profile_images/1368932180882292739/qLFkdAgX_400x400.jpg",
      borderRadius:10,
      letterSpacing:0.5,
    }

    if(theme === 'Wimbledon'){
      style = {
        background_main:"white",
        background_match:'#EDEEF5',
        background_tnns:'#48167A',
        background_scores:"#EDEEF5",
        background_ticker:'#EDEEF5',
        font_ticker:'#48167A',
        font_color:'#48167A',
        game_color:'#48167A',
        set_color:'#48167A',
        player_color:'#48167A',
        player_font:'Averta-Bold',
        ball_color:'#FBF508',
        event_logo:"https://upload.wikimedia.org/wikipedia/en/thumb/b/b9/Wimbledon.svg/1200px-Wimbledon.svg.png",
        borderRadius:0,
        leftTab:'#0B6F3D',
        hideFlags:true,
        letterSpacing:0.5,
        reverseOrder:true,
      }
    }

    if(theme === 'Roland Garros'){
      style = {
        background_main:"white",
        background_match:'#063F35',
        background_tnns:'#063F35',
        background_scores:"#ECECEC",
        background_ticker:'#EDEEF5',
        font_ticker:'#7C3B10',
        font_color:'white',
        game_color:'#7C3B10',
        set_color:'black',
        player_color:'white',
        player_font:'Averta-Bold',
        // ball_color:"#E7946B",
        ball_color:'#F4E820',
        //D45622
        event_logo:"https://upload.wikimedia.org/wikipedia/en/thumb/1/1d/Logo_Roland-Garros.svg/1200px-Logo_Roland-Garros.svg.png",
        borderRadius:2.5,
        letterSpacing:0.5,
        hideFlags:true,
        reverseOrder:true,
      }
    }

    return this.setState({style, theme})
  }

  //String changers
  changeString_stats = async () => {
    clearTimeout(this.updateString_stats)

    var { activeIndex_stats, stats } = this.state
    var nextIndex = activeIndex_stats+1
    if((activeIndex_stats+1) >= (stats.length)){
      nextIndex = 0
    }

    var string_stats = stats[nextIndex]

    await this.setState({string_stats, activeIndex_stats:nextIndex})

    this.updateString_stats = setTimeout(async () => {
      this.changeString_stats()
    }, stringChangeTime)
  }

  changeString_tippers = async () => {
    clearTimeout(this.updateString_tippers)
    var { activeIndex_tippers, tippers } = this.state

    var nextIndex = activeIndex_tippers+1
    if((activeIndex_tippers+1) >= (tippers.length)){
      nextIndex = 0
    }

    var string_tippers = tippers[nextIndex]
    await this.setState({string_tippers, activeIndex_tippers:nextIndex})

    this.updateString_tippers = setTimeout(async () => {
      this.changeString_tippers()
    }, stringChangeTime / 2)
  }

  changeImage = async () => {
    var newImage = prompt('Change the image by entering the new URL')

    if(newImage){
      var style = this.state.style
      style.event_logo = newImage
      this.setState({style})
    }
  }


  //Renders
  renderScoreboard = () => {
    var { string_stats, string_tippers } = this.state
    return(
      <View style={[{width:'100%', backgroundColor:this.state.style.background_main, padding:spacing}, MainStyles.flexCenter]}>
        {this.renderTicker(string_tippers, 'Top Tippers')}
        <View style={[{width:'100%', paddingVertical:spacing}, MainStyles.flexRow, MainStyles.flexCenter]}>
          {
            this.renderFeatureCard()
          }
          {this.renderScore()}
          {this.renderImage({uri:this.state.style.event_logo}, true, this.changeImage)}
          {
            // this.renderImage({uri:'https://yt3.ggpht.com/ytc/AAUvwnjwFNOi01eEXz_zi3Y5h1OsCYFoCRRwNn8EKGU6QQ=s176-c-k-c0x00ffffff-no-rj'})
          }
        </View>
        {this.renderTicker(string_stats, this.state.stats_title)}
      </View>
    )
  }

  renderTicker = (string, title) => {
    return(
        <View style={[{width:'100%', backgroundColor:this.state.style.background_main, height:32, paddingHorizontal:0}, MainStyles.flexCenter]}>

          <View style={[{width:'100%', backgroundColor:this.state.style.background_ticker, height:'100%'}, MainStyles.flexRow, MainStyles.flexStartCenter]}>
            <View style={[{height:'100%', paddingHorizontal:spacing*2, backgroundColor:'rgba(0,0,20,0.15)'}, MainStyles.flexCenter]}>
              <Text style={{fontSize:15, color:this.state.style.font_ticker, fontFamily:'Averta-Bold', textAlign:'left'}}>
              {title}
              </Text>
            </View>

            <View style={[{flexGrow:1}, MainStyles.flexCenterStart]}>
              <Text style={{fontSize:15, color:this.state.style.font_ticker, fontFamily:'Averta-Bold', textAlign:'left', paddingLeft:spacing*2}}>
              {string}
              </Text>
            </View>
          </View>

        </View>
    )
  }

  renderFeatureCard = () => {
    return(
      <View style={[{width:height*1.5, height, borderRadius:this.state.style.borderRadius, backgroundColor:this.state.style.background_tnns}, MainStyles.flexCenter]}>
        <Image
        style={{resizeMode:'contain', width:'100%', height:'100%'}}
        source={require('../../images/poweredbytnns.png')}
        />
      </View>
    )
  }

  renderImage = (source, disableMargin, onPress) => {
    return(
      <Pressable onPress={onPress || null}>
        <Image
        style={{height, width:height, borderRadius:this.state.style.borderRadius, marginLeft:disableMargin ? 0 : spacing, resizeMode:'cover'}}
        source={source}
        />
      </Pressable>
    )
  }

  //Score renders
  renderScore = () => {
    var item = this.state.match
    return(
      <View style={[{height, flexGrow:1, borderRadius:this.state.style.borderRadius, marginHorizontal:spacing, backgroundColor:this.state.style.background_match, overflow:'hidden'}, MainStyles.flexRow, MainStyles.flexCenter]}>
        {
          !this.state.style.leftTab ? null :
          <View style={{height:'100%', width:10, marginRight:5, backgroundColor:this.state.style.leftTab}}/>
        }
        <View style={[{flexGrow:1, height:'100%'}, MainStyles.flexBetweenCenter, MainStyles.flexRow]}>
          <View style={[{flexGrow:1, marginRight:spacing*2, paddingLeft:spacing/2}, MainStyles.flexColumn, MainStyles.flexCenterStart]}>
            {this.renderPlayer(item.competitors[0], 0, item.winner_id, item.seeds)}
            <View style={{height:10}}/>
            {this.renderPlayer(item.competitors[1], 1, item.winner_id, item.seeds)}
          </View>
          {this.renderVisualScores(item)}
        </View>
      </View>
    )
  }

  renderPlayer = (item, index, winner_id, seeds) => {

    var winner = winner_id ? winner_id === item.id : true
    var textStyle = {fontSize:24, color:this.state.style.player_color, fontFamily:this.state.style.player_font, textAlign:'left', letterSpacing:this.state.style.letterSpacing}

    var flag = item.flag

    var isDoubles = item.name.includes("/")

    if(isDoubles || this.state.style.hideFlags){
      flag = null
    }

    var game = this.state.match.game_state || {}
    var player_gs_id = index === 0 ? 'home' : 'away'
    var isServing = game.serving === player_gs_id && !winner_id

    var renderServing = null

    if(isServing){
      renderServing = <View style={{height:16, width:16, borderRadius:100, backgroundColor:this.state.style.ball_color, marginLeft:15}}/>

      if(this.state.theme === 'Wimbledon'){
        renderServing =
        <Image
        style={{width:9, height:18, resizeMode:'contain', tintColor:this.state.style.player_color, marginLeft:15}}
        source={require('../scorearrow.png')}
        />
      }
    }

    var seed = null
    if(seeds){
      seed = seeds[item.id]
    }


    return(
      <View style={[MainStyles.flexRow, MainStyles.flexStartCenter, {flexGrow:1}]}>
        <Text style={[{fontSize:24, position:'absolute', left:10}]} numberOfLines={1}>
        {flag}
        </Text>

        <Text style={[textStyle,{opacity:winner ? 1 : 0.5, marginLeft:!flag ? 10 : 45, textTransform:'uppercase'}]} numberOfLines={1}>
        {item.name}
        </Text>
        <Text style={[textStyle, {opacity:0.33, marginLeft:10, fontFamily:'Averta-Bold'}]}>
        {seed}
        </Text>

        {renderServing}
      </View>
    )
  }

  renderVisualScores = (data) => {
    //Setup number of sets required
    var best_of = data.best_of || 3
    var scores = data.period_scores ? new Array(data.period_scores.length) : []
    scores.fill('')

    var height = 46

    return(
      <View style={[{height:'100%', backgroundColor:this.state.style.background_scores}, MainStyles.flexRow, MainStyles.flexEndCenter]}>
        {
          this.state.style.reverseOrder ?
          <View style={[MainStyles.flexRow, MainStyles.flexCenter, {marginRight:-4}]}>
          {scores.map((item, index) => this.renderVisualSetScores(data.period_scores, index, height))}
          {this.renderVisualGameScore(data, height)}
          </View>
          :
          <View style={[MainStyles.flexRow, MainStyles.flexCenter, {marginRight:-4}]}>
          {this.renderVisualGameScore(data, height)}
          {scores.map((item, index) => this.renderVisualSetScores(data.period_scores, index, height))}
          </View>
        }

        {this.renderVisualArrow(data, height)}
      </View>
    )
  }

  renderVisualArrow = (data, height) => {
    return(
      <View style={[MainStyles.flexColumn, MainStyles.flexCenter, {marginLeft:10, height:height}]}>
        {this.renderArrow(data.competitors[0].id === data.winner_id, height/1.2)}
        {this.renderArrow(data.competitors[1].id === data.winner_id, height/1.2)}
      </View>
    )
  }

  renderArrow = (active, height) => {
    if(active){
      return(
        <View style={[{height}, MainStyles.flexCenter]}>
          <Image
          style={{width:9, height:18, resizeMode:'contain', tintColor:this.state.style.set_color}}
          source={require('../scorearrow.png')}
          />
        </View>
      )
    }else{
      return(
        <View style={{width:6, height}}/>
      )
    }
  }

  renderVisualGameScore = (data, height) => {
    var { mode } = this.state
    if(!data.winner_id && mode !== 'scheduled' && data.game_state){

      var scores = [0,0]
      if(data.game_state){
        scores = [data.game_state.home_score || 0, data.game_state.away_score || 0]
      }

      return(
        <View key={'gamescore'} style={[MainStyles.flexColumn, MainStyles.flexCenter, {marginLeft:20, marginRight:10, height, width:30}]}>
          {this.renderVisualSetScore(scores[0], null, null, null, true, data.tiebreak_scores, this.state.style.game_color)}
          <View style={{height:10, width:'100%', backgroundColor:'rgba(255,255,255,0.0)'}}/>
          {this.renderVisualSetScore(scores[1], null, null, null, true, data.tiebreak_scores, this.state.style.game_color)}
        </View>
      )
    }else{return null}
  }

  renderVisualSetScores = (scores, index, height, data, tiebreak_scores) => {
    var setScore = scores ? (scores[index] ? [scores[index].home_score, scores[index].away_score] : ['','']) : ['', '']
    var showScores = this.state.mode !== 'scheduled'
    return(
      <View key={index} style={[MainStyles.flexColumn, MainStyles.flexCenter, {marginLeft:10, height, width:20}]}>
        {showScores ? this.renderVisualSetScore(setScore[0], setScore[1], index+1, 'home', setScore[0] >= setScore[1], tiebreak_scores, this.state.style.set_color) : null}
        <View style={{height:10, width:'100%', backgroundColor:'rgba(255,255,255,0.0)'}}/>
        {showScores ? this.renderVisualSetScore(setScore[1], setScore[0], index+1, 'away', setScore[1] >= setScore[0], tiebreak_scores, this.state.style.set_color) : null}
      </View>
    )
  }

  renderVisualSetScore = (score, otherScore, set, player, active, tiebreak_scores, color) => {
    var tb = null
    // if(score === 0){score = '0'}
    if(score === 50){score = 'AD'}
    // if(score === 6 && otherScore === 7){
    //   if(tiebreak_scores?[set]){
    //     tb =
    //     <Text style={{position:'absolute', top:-6, right:-6, fontSize:12, fontFamily:'Averta-Bold', color:'white', opacity:active ? 1 : 0.5, letterSpacing:-0}}>
    //     {tiebreak_scores[set][player]}
    //     </Text>
    //   }
    // }

    return(
      <View style={[MainStyles.flexCenter]}>
        <Text style={{fontSize:24, color, fontFamily:this.state.style.player_font, textAlign:'left', letterSpacing:-0}}>
        {score}
        </Text>
        {tb}
      </View>
    )
  }

  //Buttons
  renderButtons = () => {
    var options = ['Wimbledon', 'Roland Garros', 'Default']

    return(
      <View style={[{width:'100%', marginTop:40}, MainStyles.flexCenter]}>

        <Pressable onPress={this.reset} style={{padding:20, minWidth:140, backgroundColor:'#2C1470', borderRadius:10, marginHorizontal:10, marginBottom:20}}>
          <Text style={{color:'white', fontFamily:'Averta-Bold', fontSize:16, textAlign:'center', opacity:1}}>
          Back to Match List
          </Text>
        </Pressable>

        <Text style={{color:'white', fontFamily:'Averta-Regular', fontSize:16, textAlign:'center', opacity:0.5, marginTop:5}}>
        Pick a theme
        </Text>
        <View style={[{width:'100%', padding:20, flexWrap:'wrap', marginTop:0}, MainStyles.flexRow, MainStyles.flexCenter]}>
        {options.map((item, index) => this.renderOption(item, index))}
        </View>
      </View>
    )
  }

  renderOption = (item, index) => {
    return(
      <Pressable onPress={()=>this.changeTheme(item)} style={{padding:20, minWidth:140, backgroundColor:'#2C1470', borderRadius:10, marginHorizontal:10}}>
        <Text style={{color:'white', fontFamily:'Averta-Bold', fontSize:16, textAlign:'center', opacity:1}}>
        {item}
        </Text>
      </Pressable>
    )
  }


  //Select match
  renderSelectMatch = () => {
    var { loading, matches } = this.state
    return(
      <View style={[{flex:1, width:'100%', height:'100%'}, MainStyles.flexCenter]}>
        {
          loading ?
          <Text style={{fontSize:24, color:'white', fontFamily:'Averta-Bold', textAlign:'center', letterSpacing:0}}>
          Loading matches
          </Text>
          :
          this.renderMatchOptions()
        }
      </View>
    )
  }

  renderMatchOptions = () => {
    var { matches } = this.state
    return(
      <View style={[{flex:1, width:'100%', height:'100%'}, MainStyles.flexCenter]}>
      <FlatList
      style={[{flex:1, width:'100%'}]}
      contentContainerStyle={[{width:'100%'}, MainStyles.flexCenter]}
      renderItem={this.renderMatch}
      data={matches}
      ListHeaderComponent={
        <View style={[{width:600}, MainStyles.flexRow, MainStyles.flexBetweenCenter]}>
          <View style={[MainStyles.flexCenterStart]}>
            <Text style={{color:'white', fontFamily:'Averta-Black', fontSize:32, textAlign:'left', marginTop:40}}>
            Upcoming coverage
            </Text>
            <Text style={{color:'white', fontFamily:'Averta-Regular', fontSize:16, textAlign:'left', marginTop:10, marginBottom:20, opacity:0.5}}>
            Tap a match to open its scoreboard
            </Text>
          </View>
          <View style={[MainStyles.flexCenter, {marginTop:20}]}>
            <Image
            style={{height:60, width:60, borderRadius:100, resizeMode:'cover', marginBottom:0, backgroundColor:'rgba(255,255,255,0.05)'}}
            source={{uri:"https://yt3.ggpht.com/ytc/AAUvwnjwFNOi01eEXz_zi3Y5h1OsCYFoCRRwNn8EKGU6QQ=s176-c-k-c0x00ffffff-no-rj"}}
            />
            <Image
            style={{height:16, width:16, borderRadius:100, resizeMode:'contain', marginTop:-8,marginBottom:0, backgroundColor:'rgba(255,255,255,0.05)', borderColor:'#2C1470', borderWidth:0}}
            source={require('../appicon.png')}
            />
          </View>
        </View>
      }
      />
      </View>
    )
  }

  renderMatch = ({index, item}) => {
    var categoryColor = GLOBAL.colors.lightBlue
    var category = item.category

    if(category.includes('WTA')){ categoryColor = GLOBAL.colors.purple }
    if(category === 'Challenger'){ categoryColor = GLOBAL.colors.green }
    if(category.includes('ITF')){ categoryColor = GLOBAL.colors.darkBlue }

    return(
      <Pressable onPress={()=>this.selectMatch(item.id)} style={[{padding:10, borderRadius:10, backgroundColor:'#18181B', margin:10, width:600}, MainStyles.flexRow, MainStyles.flexBetweenCenter]}>
        <View style={[MainStyles.flexRow, MainStyles.flexCenter, {flexShrink:1}]}>
          <Text style={{color:categoryColor, fontSize:16, marginRight:10, fontFamily:'Averta-Bold'}}>
          {item.category}
          </Text>
          <Text style={{color:'white', fontSize:16, fontFamily:'Averta-Bold', flexShrink:1, marginRight:10}} numberOfLines={1}>
          {item.competitors[0].name} vs {item.competitors[1].name}
          </Text>
        </View>
        <Text style={{color:item.isLive ? GLOBAL.colors.pink : 'white', fontSize:16, fontFamily:'Averta-Regular'}}>
        {item.isLive ? "LIVE" : moment(item.start_time_timestamp, 'x').fromNow()}
        </Text>
      </Pressable>
    )
  }


  render() {
    var { loading, mode } = this.state
    return(
      <View style={[{flex:1, width:'100%', height:'100%', backgroundColor:'black'}, MainStyles.flexStartCenter]}>
        {mode === 'selectMatch' ? this.renderSelectMatch() : this.renderScoreboard() }
        {mode === 'selectMatch' ? null : this.renderButtons()}
      </View>
    )
  }
}

export default Item;
